/**
 * Mathematical tools.
 *
 * @module math
 * @license Apache-2.0
 * @author drmats
 */
import { curry } from "./func";
import { maxInt } from "./type";
export var add = curry(function (a, b) {
  return Number(a) + Number(b);
});
export var average = function average(arr) {
  return sum(arr) / arr.length;
};
export var clamp = curry(function (low, high, n) {
  return n < low ? low : n >= low && n < high ? n : high;
});
export var dec = add(-1);
export var div = curry(function (a, b) {
  return Number(a) / Number(b);
});
export var inc = add(1);
export var inv = div(1);
export var log10 = function log10(x) {
  return roundIfClose(Math.log(x) / Math.LN10);
};
export var log2 = function log2(x) {
  return roundIfClose(Math.log(x) / Math.LN2);
};
export var mod = curry(function (a, b) {
  return Number(a) % Number(b);
});
export var mul = curry(function (a, b) {
  return Number(a) * Number(b);
});
export var neg = mul(-1);
export var pow = curry(function (a, b) {
  return Math.pow(Number(a), Number(b));
});
export var product = function product(arr) {
  return arr.reduce(mul, 1);
};
export var randomInt = function randomInt() {
  return Math.floor(Math.random() * (maxInt * 1e-3));
};
export var roundIfClose = function roundIfClose(x) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
  return function (rounded) {
    return Math.abs(rounded - x) <= Math.pow(10, -precision) ? rounded : x;
  }(Math.round(x));
};
export var sub = curry(function (a, b) {
  return Number(a) - Number(b);
});
export var sum = function sum(arr) {
  return arr.reduce(add, 0);
};